// extracted by mini-css-extract-plugin
export default {"citation":"MarkdownNavLink_citation__OZFGr"};